import { apiGet, apiPost, apiPut, apiRequest } from '@/utils/request';
import { parsePaginatedResponseFull, parseListResponse } from '@/utils/apiResponse';
import { DEFAULT_PAGE_SIZE } from '@/constants/api';
import type {
  ReplyListParams,
  ReplyPhraseDimension,
  ReplyPhraseCategoryItem,
  ReplyPhraseListParams,
  ReplyPhraseItem,
  ReplyPhraseCreateParams,
  ReplyPhraseContentFields,
} from '@/types/manualReply';

export const manualReplyGroupsApi = {
  list: (channel: string) =>
    apiGet('/manual-reply-groups', { channel }).then((d) => parseListResponse(d)),
  create: (data: { name: string; channel: string }) => apiPost('/manual-reply-groups', data),
  update: (id: number, data: { name: string }) => apiPut(`/manual-reply-groups/${id}`, data),
  delete: (id: number) => apiRequest(`/manual-reply-groups/${id}`, { method: 'DELETE' }),
};

export const replyPhraseCategoriesApi = {
  list: (dimension: ReplyPhraseDimension) =>
    apiGet('/reply-phrases/categories', { dimension }).then((d) => parseListResponse(d)) as Promise<
      ReplyPhraseCategoryItem[]
    >,
  create: (data: { name: string; dimension: ReplyPhraseDimension }) =>
    apiPost('/reply-phrases/category', data),
  update: (id: number, data: { name: string }) => apiPut(`/reply-phrases/category/${id}`, data),
  delete: (id: number) => apiRequest(`/reply-phrases/category/${id}`, { method: 'DELETE' }),
  sort: (data: { category_ids: number[]; dimension: ReplyPhraseDimension }) =>
    apiPut('/reply-phrases/category-sort', data),
};

export const replyPhrasesApi = {
  list: (params: ReplyPhraseListParams = {}) =>
    apiGet('/reply-phrases', { per_page: DEFAULT_PAGE_SIZE, page: 1, ...params }).then((d) =>
      parsePaginatedResponseFull(d, { page: 1, per_page: DEFAULT_PAGE_SIZE }),
    ) as Promise<{ list: ReplyPhraseItem[]; total: number; page: number; per_page: number }>,
  create: (data: ReplyPhraseCreateParams) => apiPost('/reply-phrases', data),
  update: (id: number, data: ReplyPhraseContentFields) => apiPut(`/reply-phrases/${id}`, data),
  delete: (id: number) => apiRequest(`/reply-phrases/${id}`, { method: 'DELETE' }),
  import: (data: FormData) => apiRequest('/reply-phrases/import', { method: 'POST', data }),
};

export const manualReplyApi = {
  list: (params: ReplyListParams) =>
    apiGet('/manual-replies', { per_page: DEFAULT_PAGE_SIZE, page: 1, ...params }).then((d) =>
      parsePaginatedResponseFull(d, { page: 1, per_page: DEFAULT_PAGE_SIZE }),
    ),
  create: (data: Record<string, unknown>) => apiPost('/manual-replies', data),
  update: (id: number, data: Record<string, unknown>) => apiPut(`/manual-replies/${id}`, data),
  delete: (id: number) => apiRequest(`/manual-replies/${id}`, { method: 'DELETE' }),
};
